import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconHomeLine"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1082 1.68763C12.4635 1.1602 11.5365 1.16019 10.8918 1.68763L3.64183 7.61945C3.2356 7.95182 3 8.44899 3 8.97387V19.25C3 20.2165 3.7835 21 4.75 21H19.25C20.2165 21 21 20.2165 21 19.25V8.97387C21 8.44899 20.7644 7.95182 20.3582 7.61945L13.1082 1.68763ZM7.75 15.5C7.33579 15.5 7 15.8358 7 16.25C7 16.6642 7.33579 17 7.75 17H16.25C16.6642 17 17 16.6642 17 16.25C17 15.8358 16.6642 15.5 16.25 15.5H7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeLine;
